import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RestfulService } from 'src-ironside/services/restful.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

export type Tariff = {
    id: string;
    updatingDate: number;
    incoterm: string;
    creationDate: string;
    price: number;
    currency: string;
    applicationEndDate: number;
    applicationStartDate: number;
    placeIncoterm: string;
};

@Injectable()
export class TariffRepository extends RestfulService {
    constructor(public override httpClient: HttpClient, public override router: Router) {
        super(httpClient, router);
    }
    findByIds(ids: string[], page = 1, pageSize = 150): Observable<Tariff[]> {
        return this.doPost(`view/filtrerById/dynamic_tariff`, ids).pipe(
            map((res) => {
                
                return res?.response?.map((tariff: any) => ({
                    id: tariff.id,
                    updatingDate: tariff?.updatingDate,
                    incoterm: tariff?.incoterm?.value,
                    creationDate: tariff?.creationDate,
                    price: tariff?.price,
                    currency: TariffRepository.mapCurrencyText(tariff?.currency),
                    applicationStartDate: tariff?.applicationStartDate,
                    applicationEndDate: tariff?.applicationEndDate,
                    placeIncoterm: tariff?.placeIncoterm,
                }));
            })
        );
    }

    static mapCurrencyText(currency: any) {
        switch (currency?.value) {
            case 'EURO':
                return '€';
            case 'DOLLAR_US': 
                return '$';     
            default:
                return currency?.labels?.fr_FR;
        }
    }
}
